import { AESCryptoService } from "./cryptoService";

let accessToken: string | undefined;
let refreshToken: string | undefined;

const crypto = new AESCryptoService();

/**
 * Retrieves and decrypts authentication tokens from `localStorage`.
 *
 * This function lazily loads and decrypts the `accessToken` and `refreshToken`
 * only once per application lifecycle. The decrypted tokens are cached in
 * module-scope variables so subsequent calls return the same values without
 * re-decrypting or touching storage again.
 *
 * @returns {{ accessToken: string | undefined, refreshToken: string | undefined }}
 * An object containing the decrypted `accessToken` and `refreshToken`.
 * If no token exists in storage, the corresponding value will be `undefined`.
 */
export function authTokenService() {
  try {
    if (!accessToken) {
      const token = localStorage.getItem("accessToken");
      // FIX: Only decrypt if token exists, otherwise crypto.decrypt("") throws error
      if (token) {
        accessToken = crypto.decrypt(token);
      }
    }

    if (!refreshToken) {
      const token = localStorage.getItem("refreshToken");
      if (token) {
        refreshToken = crypto.decrypt(token);
      }
    }
  } catch (err) {
    console.error("❌ AUTH: Failed to decrypt tokens:", err);
  }

  return { accessToken, refreshToken };
}

export function clearAuthToken() {
  accessToken = undefined;
  refreshToken = undefined;
}
